import { useWorkSpaces } from "api/workSpaces";
import {
  ListCard,
  ListIconWrapper,
  Loader,
  LoadingListCards,
  MainButton,
  PrimaryHeading,
} from "commonUI";
import "./auth.css";
import { useState } from "react";
import { useUserAuth } from "context/UserAuth";
import { useNavigate } from "react-router-dom";
import { activateLicense, useCheckKeyStatus } from "api/userAuth";
import { useUtilities } from "helpers";
import { ApiResponseType, NotificationType } from "enums";
import { t } from "i18next";
import { Logo, RightArrow } from "allIcons";
import { useUserLogout } from "hooks/user";
import { checkRolePermission } from "./auth";

const WorkSpaces = () => {
  const { data, isLoading } = useWorkSpaces();
  const [selectedWorkspace, setSelectedWorkspace] = useState("");
  const { notification } = useUtilities();
  const { setUserAuth } = useUserAuth();
  const navigate = useNavigate();

  const { mutate: logout, isLoading: logingout } = useUserLogout();

  const { mutateAsync: checkKeyStatus, isLoading: checkingKeyStatus } =
    useCheckKeyStatus();

  const createUserSession = () => {
    localStorage.setItem("apikey", selectedWorkspace.key);
    setUserAuth((pre) => ({
      ...pre,
      apikey: selectedWorkspace.key,
    }));
    navigate("/");
  };

  const handleProceed = (event) => {
    event.preventDefault();
    const isUserAllowed = checkRolePermission(
      selectedWorkspace.current_user.role.app_permissions
    );
    if (!isUserAllowed) {
      notification({
        message: t("workspace.error.noLoginPermission"),
        type: NotificationType.ERROR,
      });
      return;
    }
    checkKeyStatus({ api_key: selectedWorkspace.key })
      .then((res) => {
        console.log(res);
        if (res.status_code === ApiResponseType.SUCCESS) {
          createUserSession();
        } else {
          activateLicense({
            api_key: selectedWorkspace.key,
          }).then((res) => {
            if (res.status_code === ApiResponseType.SUCCESS) {
              createUserSession();
            } else {
              notification({
                message: t("workspace.error.licenseNotActivated"),
                type: "error",
              });
            }
          });
        }
      })
      .catch((err) => {
        notification({
          message: t("workspace.error.licenseNotActivated"),
          type: "error",
        });
      });
  };

  return (
    <>
      <Loader show={checkingKeyStatus || logingout} />
      <div className={`login-container`}>
        <div className="">
          <div
            className={`flex items-center bg-transparent mb-[87px] justify-center`}
          >
            <Logo className="logo-size" />
          </div>
          <div
            className="login-form"
            style={{ padding: "119px 107px", width: "452px" }}
          >
            <PrimaryHeading className="login-heading w-full">
              {t("workspace.select")}
            </PrimaryHeading>
            <div className="w-full mx-auto">
              {isLoading ? (
                <LoadingListCards />
              ) : (
                (data || []).map((ele) => {
                  return (
                    <ListCard
                      selected={ele.id === selectedWorkspace.id}
                      data={
                        ele?.featureSetting?.brand_colors_settings
                          ?.product_name || ele.title
                      }
                      onClick={() => setSelectedWorkspace(ele)}
                      icon={
                        <ListIconWrapper className="border-white text-white bg-theme-card-bg hover:bg-theme-card-bg">
                          {ele?.featureSetting?.brand_colors_settings
                            ?.product_logo ? (
                            <img
                              src={
                                ele?.featureSetting?.brand_colors_settings
                                  ?.product_logo
                              }
                              alt={
                                ele?.featureSetting?.brand_colors_settings
                                  ?.product_name || ele.title
                              }
                              className="w-full h-full object-contain rounded-full"
                            />
                          ) : (
                            ele?.featureSetting?.brand_colors_settings?.product_name[0]?.toUpperCase()
                          )}
                        </ListIconWrapper>
                      }
                      rightSideContent={
                        <ListIconWrapper className="bg-transparent">
                          <RightArrow />
                        </ListIconWrapper>
                      }
                      deleteIcon={true}
                      editIcon={false}
                      secondaryData={`${ele?.owner?.name} ${ele?.owner?.last_name}`}
                    />
                  );
                })
              )}
              <MainButton
                className="workspace-container-proceed-button"
                disabled={!selectedWorkspace}
                onClick={handleProceed}
              >
                {t("workspace.button.continue")}
              </MainButton>
              <MainButton
                buttonType="secondary"
                className="w-full mt-2 py-2-5"
                onClick={logout}
              >
                {t("header.menu.logout")}
              </MainButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkSpaces;
